
let lastScrollTop = 0;
window.addEventListener('scroll', (e) => {
  const st = window.pageYOffset || document.documentElement.scrollTop;
  //headerHeight();

  if (st > lastScrollTop) {
    // downscroll code
    window.scrollDirection = 'down';
  }
  else {
    // upscroll code
    window.scrollDirection = 'up';
  }

  lastScrollTop = st <= 0 ? 0 : st;
});
